import logo from "../assets/img/logo.png";
import garlic from "../assets/img/20-1.png";
import veg from "../assets/img/26-1.png";
import background from "../assets/img/Azzir_Background_Image.jpg";
import appBackground from "../assets/img/app-bg.png";
import aboutBackground from "../assets/img/about-sec-bg.png";
import calendar from "../assets/img/calendar-icon.svg";
import drinkIcon from "../assets/img/drink-icon.svg";
import guitarIcon from "../assets/img/guitar-icon.svg";
import heroImg from "../assets/img/hero-img.jpg";
import innerHeadImg from "../assets/img/inner-head-img.jpg";
import meatballWithParsley from "../assets/img/meatball-with-parsley.jpg";
import nounRosemary from "../assets/img/noun-rosemary.png";
import redTazhinWithVegetables from "../assets/img/red-tazhin-with-vegetables.jpg";
import appleDownload from "../assets/img/a-b-img.png";
import appleDownloadw from "../assets/img/a-w-img.png";
import androidDownload from "../assets/img/g-b-img.png";
import androidDownloadw from "../assets/img/g-w-img.png";
import areaImage from "../assets/img/areaImage.jpeg";
import genreImage from "../assets/img/genreImage.jpg";
import artistImage from "../assets/img/artistImage.png";
import clubImage from "../assets/img/clubImage.png";
import emptyHeart from "../assets/img/emptyheart.png";
import filledHeart from "../assets/img/filledheart.png";
import hero from "../assets/img/hero.png";
import screen1 from "../assets/img/app-screen-1.png";
import screen2 from "../assets/img/app-screen-2.png";
import screen3 from "../assets/img/app-screen-3.png";
import banner from "../assets/img/banner_cricket_sep2025_1.jpeg";
import bannerMobile from "../assets/img/banner_cricket_sep2025_2.jpeg";
export default {
  logo,
  garlic,
  veg,
  background,
  appBackground,
  aboutBackground,
  calendar,
  drinkIcon,
  guitarIcon,
  heroImg,
  innerHeadImg,
  meatballWithParsley,
  nounRosemary,
  redTazhinWithVegetables,
  appleDownload,
  androidDownload,
  areaImage,
  genreImage,
  artistImage,
  clubImage,
  emptyHeart,
  filledHeart,
  hero,
  screen1,
  screen2,
  screen3,
  appleDownloadw,
  androidDownloadw,
  banner,
  bannerMobile,
};
